<div class="controls-container">
    <div class="controls-header">Check box list box</div>

    <div class="controls-sub-header">Check box list box Default</div>
    <pm-check-box-list-box 
        DisplayMemberPath="Name"
        [ItemsSource]="ItemsSource"
        [(SelectedItems)]="SelectedItems">
    </pm-check-box-list-box>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/check-box-list-box/check-box-list-box.html